import IComp from '@/models/Comp';

export default interface IUpsertCompDataRequest {
    comp: IComp;
    fieldId?: number | null;
    fieldName?: string;
    fieldRulesApplied?: boolean | null;
    include?: string | null;
    sourceInitial?: string;
    sourceInitialIdx?: number | undefined;
    value?: string;
    description?: string; // optionally allows specifying where the request is originating from
}

export function newUpsertCompDataRequestByFieldId(comp: IComp, fieldId: number): IUpsertCompDataRequest {
    const result: IUpsertCompDataRequest = {
        comp: comp,
        fieldId: fieldId
    };
    return result;
}

export function newUpsertCompDataRequestByFieldName(comp: IComp, fieldName: string): IUpsertCompDataRequest {
    const result: IUpsertCompDataRequest = {
        comp: comp,
        fieldName: fieldName
    };
    return result;
}
